import { browserHistory } from 'react-router';

export const justSubscribed = () =>
  browserHistory.getCurrentLocation().query.subscribed === 'true';
